module.exports = __webpack_public_path__ + "img/loisir8.b73235ea.jpg";